import { render, staticRenderFns } from "./LocationRegionPerformance.vue?vue&type=template&id=4d1736f6&scoped=true&"
import script from "./LocationRegionPerformance.vue?vue&type=script&lang=ts&"
export * from "./LocationRegionPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./LocationRegionPerformance.vue?vue&type=style&index=0&id=4d1736f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1736f6",
  null
  
)

export default component.exports